export default __webpack_public_path__ + "static/media/perths_best_girls.23bb54a5.png";